import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsOptional } from 'class-validator';
import { LoyaltyProgramExposeGroupEnum, LoyaltyProgramTypeEnum } from '../interface';
export class ListLoyaltyProgramDto {
    constructor() {
        this.type = LoyaltyProgramTypeEnum.REGULAR;
    }
}
__decorate([
    ApiPropertyOptional({ enum: LoyaltyProgramTypeEnum, default: LoyaltyProgramTypeEnum.REGULAR }),
    Expose({
        groups: [
            LoyaltyProgramExposeGroupEnum.READ,
            LoyaltyProgramExposeGroupEnum.PUT,
            LoyaltyProgramExposeGroupEnum.CREATE,
            LoyaltyProgramExposeGroupEnum.LIST,
        ],
    }),
    IsOptional({ groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.LIST] }),
    IsNotEmpty({ always: true }),
    IsEnum(LoyaltyProgramTypeEnum, { always: true }),
    __metadata("design:type", String)
], ListLoyaltyProgramDto.prototype, "type", void 0);
//# sourceMappingURL=ListLoyaltyProgramDto.js.map